import Workout from "../workout/workout";
import WorkoutLesson1 from "./workout-lesson1";

export default WorkoutLesson1;